import type { FC } from 'react';

import styles from './MobileOnboardingInputs.module.scss';

const MobileOnboardingInputsSection: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['inputs-section']}>{children}</div>;
};

const MobileOnboardingInputsSectionHeader: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <h2 className={styles['inputs-section-header']}>{children}</h2>;
};

const MobileOnboardingInputsSectionHeaderContainer: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['inputs-section-header-container']}>{children}</div>;
};

const MobileOnboardingInputsGroup: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['inputs-group']}>{children}</div>;
};

const MobileOnboardingNextButtonContainer: FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  return <div className={styles['next-button-container']}>{children}</div>;
};

export {
  MobileOnboardingInputsSection,
  MobileOnboardingInputsSectionHeader,
  MobileOnboardingInputsSectionHeaderContainer,
  MobileOnboardingInputsGroup,
  MobileOnboardingNextButtonContainer,
};
